'use strict';
/* eslint-disable no-console */
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportError = undefined;

var _getExtraErrorData = require('./getExtraErrorData');

/**
 * @description
 * Report an error to sentry and new relic for more info on fingerprints see
 * https://blog.sentry.io/2018/01/18/setting-up-custom-fingerprints
 *
 * For help with tagging, see:
 * https://docs.sentry.io/enriching-error-data/context/?platform=javascript#tagging-events
 *
 * To enable local debugging, set the following option:
 * `localStorage.setItem('SENTRY_DEPLOYED', true);`
 *
 * Per the following Sentry issue, Sentry will automatically combine and throw out messages that
 * share similar stack traces. This makes it impossible to debug local errors since React will
 * cause errors to bubble up through `componentDidCatch` methods, forcing Sentry to effectively log
 * these errors twice. In order to work around this, building a new error in place inside the
 * `componentDidCatch` and attaching the stacktrace as a custom field of that error allows it to
 * reach Sentry.
 * https://github.com/getsentry/sentry-javascript/issues/1249
 *
 * @param {Object} options
 * @param {Error} options.error Error to report
 * @param {Array} options.fingerprint Sentry error fingerprint
 * @param {Object} options.tags Sentry error tags { key: 'value' }
 * @returns {string} Sentry event id
 */
var reportError = exports.reportError = function reportError(_ref) {
  var error = _ref.error,
      fingerprint = _ref.fingerprint,
      _ref$tags = _ref.tags,
      tags = _ref$tags === undefined ? {} : _ref$tags;

  var extraData = (0, _getExtraErrorData.getExtraErrorData)(error);

  if (window.newrelic && window.newrelic.noticeError) {
    window.newrelic.noticeError(error);
  }

  window.Raven.captureException(error, {
    fingerprint: fingerprint,
    tags: tags,
    extra: { error: extraData }
  });

  var lastEventId = window.Raven.lastEventId();

  console.error('(Event Id: ' + lastEventId + ')\nError reported with \'' + error.message + '\'');

  if (extraData) {
    Object.keys(extraData).forEach(function (key) {
      if (extraData[key]) {
        console.error('Extra Data [' + key + ']: ', extraData[key]);
      }
    });
  }

  return lastEventId;
};